import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CommonService } from '@app/core/Services';

@Component({
  selector: 'app-gateway-detail',
  templateUrl: './gateway-detail.component.html',
  styleUrls: ['./gateway-detail.component.scss']
})
export class GatewayDetailComponent implements OnInit, OnChanges {
  @Input() formDetails: FormGroup;
  @Input() recordId: any;
  @Input() gatewayDetails: any;

  constructor(private commonService: CommonService) { }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes['gatewayDetails']){
      this.setValue();
    }
  }

  setForm(): void{
    this.formDetails = new FormGroup({
      presenterId: new FormControl('', [Validators.required,]),
      authenticationCode: new FormControl('', [Validators.required,]),
      email: new FormControl(''),
      companyAuthorisationId: new FormControl('', [Validators.required,]),
    });
  }

  setValue(): void{
    this.formDetails?.patchValue({
      presenterId: this.gatewayDetails?.presenterId,
      authenticationCode: this.gatewayDetails?.authenticationCode,
      email: this.gatewayDetails?.email,
      companyAuthorisationId: this.gatewayDetails?.companyAuthorisationId,
    });
  }

}
